<template>
  <div class="full-view"
       :style="'background-image: url(\'' + settings.staticImageUrl + '/403-fence.jpg\')'"
  >
    <mdb-mask class="gradient d-flex justify-content-center align-items-center overflow-auto">
      <mdb-card>
        <mdb-card-header class="danger-color text-white">
          <h5>Not Authorized
            <mdb-icon icon="lock"/>
          </h5>
        </mdb-card-header>
        <mdb-card-body class="text-center">
          <div v-if="!loggedIn">
            <h5>You tried to access a page which requires you to be logged in. Please log in and try again.
            </h5>
            <mdb-btn @click="$router.push('/login')">Login</mdb-btn>
          </div>
          <div v-if="loggedIn">
            <h5>You tried to access a page which you don't have access to.</h5>
          </div>
        </mdb-card-body>
      </mdb-card>
    </mdb-mask>
  </div>
</template>

<script>
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon, mdbMask, mdbView} from 'mdbvue';

export default {
    name: 'NotAuthorized403',
    components: {
      mdbContainer,
      mdbCard,
      mdbCardBody,
      mdbCardHeader,
      mdbIcon,
      mdbMask,
      mdbView,
      mdbBtn
    },
    computed: {
      loggedIn: function () {
        return this.$store.state.loggedIn
      },
      settings: function() {
        return this.$store.state.settings
      }
    },
    mounted : function() {
      if (!this.loggedIn && this.$route.query.redirect) {
        localStorage.setItem("redirectOnLogin",this.$route.query.redirect.toString())
      }
    }
  }

</script>
<style scoped>
  .gradient {
    background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
    background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
    background: -webkit-gradient(linear, 45deg, from(rgba(42, 27, 161, 0.7)), to(rgba(29, 210, 177, 0.7)));
    background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
    background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
    height: calc(100vh);
  }

  .full-view {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    height: calc(100vh);
  }
</style>
